import type { AreaDict } from '../messages'

// Tela de Transações (TransactionsPage). Prefixo: tx.
// pt-BR = textos exatos atuais do app. Reutilize common.* onde já existir.
const transactions: AreaDict = {
  'pt-BR': {
    'tx.title': 'Transações',
    'tx.subtitle': 'Consolidado em {currency}, congelado pela taxa da data.',

    // Ações do cabeçalho
    'tx.export': 'Exportar',
    'tx.exportTitle': 'Baixar as transações filtradas em CSV (Excel/Sheets)',
    'tx.includeRecurring': 'Incluir recorrente',
    'tx.transfer': 'Transferência',
    'tx.new': 'Nova transação',

    // Seletor de período
    'tx.periodHint': 'Aplique um filtro para habilitar períodos maiores',
    'tx.month': 'Mês',
    'tx.last3': 'Últimos 3 meses',
    'tx.last6': 'Últimos 6 meses',
    'tx.last12': 'Últimos 12 meses',
    'tx.year': 'Ano ({year})',
    'tx.all': 'Tudo',
    'tx.custom': 'Personalizado',

    // Rótulos do período (minúsculos, usados no estado vazio e no rótulo central)
    'tx.last3Label': 'últimos 3 meses',
    'tx.last6Label': 'últimos 6 meses',
    'tx.last12Label': 'últimos 12 meses',
    'tx.allLabel': 'todo o período',
    'tx.customLabel': 'personalizado',

    // Navegação de mês / intervalo
    'tx.prevMonth': 'Mês anterior',
    'tx.nextMonth': 'Próximo mês',
    'tx.today': 'hoje',
    'tx.until': 'até',

    // Totais
    'tx.entriesShort': 'lanç.',
    'tx.total': 'Total',

    // Filtro
    'tx.searchPlaceholder': 'Buscar descrição, categoria, conta, tag ou valor…',

    // Cabeçalhos da tabela
    'tx.colDate': 'Data',
    'tx.colDescription': 'Descrição',
    'tx.colCategory': 'Categoria',
    'tx.colAccount': 'Conta',
    'tx.colValue': 'Valor',

    // Linha de cartão (fatura)
    'tx.card': 'Cartão',
    'tx.invoice': 'fatura',
    'tx.invoicePaid': 'Paga',

    // Linha de transferência
    'tx.transferSettled': 'Transferência (liquidada)',
    'tx.fromTo': 'De: {from}  →  Para: {to}',
    'tx.deleteTransfer': 'Excluir transferência',

    // Linha de transação
    'tx.markPaid': 'Marcar como pago',
    'tx.markPending': 'Marcar como pendente',
    'tx.pending': 'Pendente',
    'tx.noCategory': 'Sem categoria',
    'tx.conversionPending': 'Conversão pendente',
    'tx.duplicate': 'Duplicar',

    // Estado vazio
    'tx.empty': 'Nenhuma transação em {periodo}',
    'tx.emptyDesc': 'Registre uma transação, transfira entre contas ou inclua um recorrente do mês.',

    // Confirmações
    'tx.confirmDeleteTitle': 'Excluir transação?',
    'tx.confirmDeleteTransferTitle': 'Excluir transferência?',
    'tx.confirmDeleteDesc': 'Esta ação não pode ser desfeita.',
    'tx.confirmDeleteTransferDesc':
      'É uma transferência: as duas pernas (nas duas contas) serão excluídas. Esta ação não pode ser desfeita.',
    'tx.confirmDeleteTransferDesc2':
      'As duas pernas (nas duas contas) serão excluídas. Esta ação não pode ser desfeita.',

    // Toasts
    'tx.errorSave': 'Erro ao salvar',
    'tx.errorDelete': 'Erro ao excluir',
    'tx.errorStatus': 'Erro ao atualizar status',
    'tx.transferDeleted': 'Transferência excluída',
    'tx.transactionDeleted': 'Transação excluída',
    'tx.markedPaid': 'Marcado como pago',
    'tx.markedPending': 'Marcado como pendente',
    'tx.exportedOne': '1 transação exportada',
    'tx.exportedMany': '{count} transações exportadas',

    // CSV
    'tx.csvType': 'Tipo',
    'tx.csvCurrency': 'Moeda',
    'tx.csvValueBase': 'Valor {currency}',
    'tx.csvStatus': 'Status',
    'tx.csvInstallment': 'Parcela',
    'tx.csvTags': 'Tags',
    'tx.income': 'Receita',
    'tx.expense': 'Despesa',
    'tx.statusPaid': 'Pago',
    'tx.fileBase': 'transacoes',
    'tx.fileTo': 'a',
    'tx.fileAll': 'transacoes_todas',
  },
  en: {
    'tx.title': 'Transactions',
    'tx.subtitle': 'Consolidated in {currency}, frozen at the date’s rate.',

    'tx.export': 'Export',
    'tx.exportTitle': 'Download the filtered transactions as CSV (Excel/Sheets)',
    'tx.includeRecurring': 'Include recurring',
    'tx.transfer': 'Transfer',
    'tx.new': 'New transaction',

    'tx.periodHint': 'Apply a filter to enable longer periods',
    'tx.month': 'Month',
    'tx.last3': 'Last 3 months',
    'tx.last6': 'Last 6 months',
    'tx.last12': 'Last 12 months',
    'tx.year': 'Year ({year})',
    'tx.all': 'All',
    'tx.custom': 'Custom',

    'tx.last3Label': 'last 3 months',
    'tx.last6Label': 'last 6 months',
    'tx.last12Label': 'last 12 months',
    'tx.allLabel': 'all time',
    'tx.customLabel': 'custom',

    'tx.prevMonth': 'Previous month',
    'tx.nextMonth': 'Next month',
    'tx.today': 'today',
    'tx.until': 'to',

    'tx.entriesShort': 'entries',
    'tx.total': 'Total',

    'tx.searchPlaceholder': 'Search description, category, account, tag or amount…',

    'tx.colDate': 'Date',
    'tx.colDescription': 'Description',
    'tx.colCategory': 'Category',
    'tx.colAccount': 'Account',
    'tx.colValue': 'Amount',

    'tx.card': 'Card',
    'tx.invoice': 'invoice',
    'tx.invoicePaid': 'Paid',

    'tx.transferSettled': 'Transfer (settled)',
    'tx.fromTo': 'From: {from}  →  To: {to}',
    'tx.deleteTransfer': 'Delete transfer',

    'tx.markPaid': 'Mark as paid',
    'tx.markPending': 'Mark as pending',
    'tx.pending': 'Pending',
    'tx.noCategory': 'No category',
    'tx.conversionPending': 'Pending conversion',
    'tx.duplicate': 'Duplicate',

    'tx.empty': 'No transactions in {periodo}',
    'tx.emptyDesc': 'Record a transaction, transfer between accounts, or include a recurring one for the month.',

    'tx.confirmDeleteTitle': 'Delete transaction?',
    'tx.confirmDeleteTransferTitle': 'Delete transfer?',
    'tx.confirmDeleteDesc': 'This action cannot be undone.',
    'tx.confirmDeleteTransferDesc':
      'It’s a transfer: both legs (in both accounts) will be deleted. This action cannot be undone.',
    'tx.confirmDeleteTransferDesc2':
      'Both legs (in both accounts) will be deleted. This action cannot be undone.',

    'tx.errorSave': 'Error saving',
    'tx.errorDelete': 'Error deleting',
    'tx.errorStatus': 'Error updating status',
    'tx.transferDeleted': 'Transfer deleted',
    'tx.transactionDeleted': 'Transaction deleted',
    'tx.markedPaid': 'Marked as paid',
    'tx.markedPending': 'Marked as pending',
    'tx.exportedOne': '1 transaction exported',
    'tx.exportedMany': '{count} transactions exported',

    'tx.csvType': 'Type',
    'tx.csvCurrency': 'Currency',
    'tx.csvValueBase': 'Amount {currency}',
    'tx.csvStatus': 'Status',
    'tx.csvInstallment': 'Installment',
    'tx.csvTags': 'Tags',
    'tx.income': 'Income',
    'tx.expense': 'Expense',
    'tx.statusPaid': 'Paid',
    'tx.fileBase': 'transactions',
    'tx.fileTo': 'to',
    'tx.fileAll': 'transactions_all',
  },
  es: {
    'tx.title': 'Transacciones',
    'tx.subtitle': 'Consolidado en {currency}, congelado por la tasa de la fecha.',

    'tx.export': 'Exportar',
    'tx.exportTitle': 'Descargar las transacciones filtradas en CSV (Excel/Sheets)',
    'tx.includeRecurring': 'Incluir recurrente',
    'tx.transfer': 'Transferencia',
    'tx.new': 'Nueva transacción',

    'tx.periodHint': 'Aplica un filtro para habilitar períodos más largos',
    'tx.month': 'Mes',
    'tx.last3': 'Últimos 3 meses',
    'tx.last6': 'Últimos 6 meses',
    'tx.last12': 'Últimos 12 meses',
    'tx.year': 'Año ({year})',
    'tx.all': 'Todo',
    'tx.custom': 'Personalizado',

    'tx.last3Label': 'últimos 3 meses',
    'tx.last6Label': 'últimos 6 meses',
    'tx.last12Label': 'últimos 12 meses',
    'tx.allLabel': 'todo el período',
    'tx.customLabel': 'personalizado',

    'tx.prevMonth': 'Mes anterior',
    'tx.nextMonth': 'Mes siguiente',
    'tx.today': 'hoy',
    'tx.until': 'hasta',

    'tx.entriesShort': 'mov.',
    'tx.total': 'Total',

    'tx.searchPlaceholder': 'Buscar descripción, categoría, cuenta, etiqueta o importe…',

    'tx.colDate': 'Fecha',
    'tx.colDescription': 'Descripción',
    'tx.colCategory': 'Categoría',
    'tx.colAccount': 'Cuenta',
    'tx.colValue': 'Importe',

    'tx.card': 'Tarjeta',
    'tx.invoice': 'factura',
    'tx.invoicePaid': 'Pagada',

    'tx.transferSettled': 'Transferencia (liquidada)',
    'tx.fromTo': 'De: {from}  →  Para: {to}',
    'tx.deleteTransfer': 'Eliminar transferencia',

    'tx.markPaid': 'Marcar como pagado',
    'tx.markPending': 'Marcar como pendiente',
    'tx.pending': 'Pendiente',
    'tx.noCategory': 'Sin categoría',
    'tx.conversionPending': 'Conversión pendiente',
    'tx.duplicate': 'Duplicar',

    'tx.empty': 'Ninguna transacción en {periodo}',
    'tx.emptyDesc': 'Registra una transacción, transfiere entre cuentas o incluye un recurrente del mes.',

    'tx.confirmDeleteTitle': '¿Eliminar transacción?',
    'tx.confirmDeleteTransferTitle': '¿Eliminar transferencia?',
    'tx.confirmDeleteDesc': 'Esta acción no se puede deshacer.',
    'tx.confirmDeleteTransferDesc':
      'Es una transferencia: ambas partes (en las dos cuentas) serán eliminadas. Esta acción no se puede deshacer.',
    'tx.confirmDeleteTransferDesc2':
      'Ambas partes (en las dos cuentas) serán eliminadas. Esta acción no se puede deshacer.',

    'tx.errorSave': 'Error al guardar',
    'tx.errorDelete': 'Error al eliminar',
    'tx.errorStatus': 'Error al actualizar el estado',
    'tx.transferDeleted': 'Transferencia eliminada',
    'tx.transactionDeleted': 'Transacción eliminada',
    'tx.markedPaid': 'Marcado como pagado',
    'tx.markedPending': 'Marcado como pendiente',
    'tx.exportedOne': '1 transacción exportada',
    'tx.exportedMany': '{count} transacciones exportadas',

    'tx.csvType': 'Tipo',
    'tx.csvCurrency': 'Moneda',
    'tx.csvValueBase': 'Importe {currency}',
    'tx.csvStatus': 'Estado',
    'tx.csvInstallment': 'Cuota',
    'tx.csvTags': 'Etiquetas',
    'tx.income': 'Ingreso',
    'tx.expense': 'Gasto',
    'tx.statusPaid': 'Pagado',
    'tx.fileBase': 'transacciones',
    'tx.fileTo': 'a',
    'tx.fileAll': 'transacciones_todas',
  },
}

export default transactions
